var _path, _line, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEventpl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 54,
    viewBox: "0 0 108 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 52H3V2H106V18.5C106 18.5 94 19 94 28C94 37 106 37 106 37V52H64",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: 4,
    x2: 81,
    y2: 50,
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeDasharray: "4 8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 50,
    fill: "#B31B34",
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventpl);
export default __webpack_public_path__ + "static/media/eventpl.0b56866207d40b95b07c8ddcac65dd94.svg";
export { ForwardRef as ReactComponent };